import { useAccomodationCategoryQuery } from '@/hooks/RQHooks/layout/useAccomodationCategoryQuery';
import { useExperienceCategoryQuery } from '@/hooks/RQHooks/layout/useExperienceCategoryQuery';
import { useMarketCategoryQuery } from '@/hooks/RQHooks/layout/useMarketCategoryQuery';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
export const useHomeCategorySection = () => {
  const router = useRouter();
  const type = router.query.type as '마켓' | '체험' | '숙소';

  const { data: marketCategories, isPending: isMarketCategoryPending } = useMarketCategoryQuery();
  const { data: experienceCategories, isPending: isExperienceCategoryPending } =
    useExperienceCategoryQuery();
  const { data: accommodationCategories, isPending: isAccommodationCategoryPending } =
    useAccomodationCategoryQuery();

  const isPending = useMemo(() => {
    if (type === '마켓') {
      return isMarketCategoryPending;
    } else if (type === '체험') {
      return isExperienceCategoryPending || isAccommodationCategoryPending;
    } else if (type === '숙소') {
      return isAccommodationCategoryPending;
    } else if (type === '전체') {
      return (
        isMarketCategoryPending || isExperienceCategoryPending || isAccommodationCategoryPending
      );
    }
  }, [type, isMarketCategoryPending, isExperienceCategoryPending, isAccommodationCategoryPending]);

  const categories = useMemo(() => {
    if (type === '마켓') {
      return marketCategories;
    } else if (type === '체험') {
      return [...(experienceCategories || []), ...(accommodationCategories || [])];
    } else if (type === '숙소') {
      return accommodationCategories;
    }
  }, [type, marketCategories, experienceCategories, accommodationCategories]);

  return { isPending, categories, type };
};
